import styled from "styled-components";
import { Button } from "@mui/material";

export const MaterialOrderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    height: 100%;
`;

export const StyledButton = styled(Button)`
    && {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 14px;
        padding-right: 14px;
        display: flex;
        justify-content: center;
        gap: 4px;
        font-size: 14px;
        height: 36px;
        border-radius: 5px;
        &.MuiButton-outlined {
            border-color: var(--Primary-Blue-B100, #0058a0);
            color: var(--Primary-Blue-B100, #0058a0);
        }
    }
`;
